import {
  getMarketingTopicFromRawValue as getIntl2MarketingTopicFromRawValue,
  MARKETING_TOPIC_QUERY_PARAM,
  isAdaptiveMarketingTopic as isIntl2AdaptiveMarketingTopic,
} from 'cohorts/intl_2/constants/marketing-topic'
import {
  getMarketingTopicFromRawValue as getIntl2LwMarketingTopicFromRawValue,
  isAdaptiveMarketingTopic as isIntl2LwAdaptiveMarketingTopic,
} from 'cohorts/intl_2lw/constants/marketing-topic'
import {
  getMarketingTopicFromRawValue as getIntlD60MarketingTopicFromRawValue,
  isAdaptiveMarketingTopic as isIntlD60AdaptiveMarketingTopic,
} from 'cohorts/intl_d60/constants/marketing-topic'
import {
  getMarketingTopicFromRawValue as getIntlD70MarketingTopicFromRawValue,
  isAdaptiveMarketingTopic as isIntlD70AdaptiveMarketingTopic,
} from 'cohorts/intl_d70/constants/marketing-topic'
import { getFrcEventProps } from 'helpers/getFrcEventProps'
import { getMobileOperatingSystem } from 'helpers/getMobileOperatingSystem'
import { getOperatingSystemVersion } from 'helpers/getOperatingSystemVersion'
import { Cohort, CurrentEnvironment } from 'root-constants'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const getCommonEventProps = (
  utmTags: Record<string, string>,
): Record<string, unknown> => {
  const cohort =
    useZustandStore.getState()?.lead?.cohort ||
    useZustandStore.getState()?.initialCohort ||
    ''
  const { language } = useZustandSessionStore.getState()
  const isIntl2LwCohort =
    cohort === Cohort.INTL_2LW || cohort === Cohort.INTL_HLWN70
  const isIntlD60Cohort = cohort === Cohort.INTL_D60
  const isIntlD70Cohort = cohort === Cohort.INTL_D70
  const isIntl2Cohort =
    cohort === Cohort.INTL_2 ||
    isIntl2LwCohort ||
    isIntlD60Cohort ||
    isIntlD70Cohort
  const isIntlMwCohort = cohort === Cohort.INTL_MW
  const marketingTopicRaw = isIntl2Cohort
    ? (utmTags?.[MARKETING_TOPIC_QUERY_PARAM] ?? null)
    : null
  const marketingTopic = isIntlD70Cohort
    ? getIntlD70MarketingTopicFromRawValue(marketingTopicRaw)
    : isIntlD60Cohort
      ? getIntlD60MarketingTopicFromRawValue(marketingTopicRaw)
      : isIntl2LwCohort
        ? getIntl2LwMarketingTopicFromRawValue(marketingTopicRaw)
        : getIntl2MarketingTopicFromRawValue(marketingTopicRaw)
  const isAdaptiveTopic = isIntlD70Cohort
    ? isIntlD70AdaptiveMarketingTopic(
        getIntlD70MarketingTopicFromRawValue(marketingTopicRaw),
      )
    : isIntlD60Cohort
      ? isIntlD60AdaptiveMarketingTopic(
          getIntlD60MarketingTopicFromRawValue(marketingTopicRaw),
        )
      : isIntl2LwCohort
        ? isIntl2LwAdaptiveMarketingTopic(
            getIntl2LwMarketingTopicFromRawValue(marketingTopicRaw),
          )
        : isIntl2AdaptiveMarketingTopic(
            getIntl2MarketingTopicFromRawValue(marketingTopicRaw),
          )
  const { emailConsent } = useZustandGlobalLocalStore.getState()

  return {
    is_prod_env: import.meta.env.CURRENT_ENV === CurrentEnvironment.PROD,
    cohort,
    lang: language,
    device_type: getMobileOperatingSystem(),
    operating_system_version: getOperatingSystemVersion(),
    ...(isIntl2Cohort
      ? {
          marketing_topic: marketingTopic,
          is_adaptive_marketing_topic: isAdaptiveTopic,
        }
      : {}),
    ...(isIntlMwCohort
      ? { marketing_topic: 'none', is_adaptive_marketing_topic: false }
      : {}),
    ...(emailConsent !== null && { email_consent: emailConsent }),
    ...getFrcEventProps(),
    attribution: utmTags,
    viewport_width: window.screen.width,
    viewport_height: window.screen.height,
    viewport_size: `${window.screen.width}x${window.screen.height}`,
  }
}
